'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by li on 2016/4/8.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = require('react-collapse');

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiddleNav = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MiddleNav, _Component);

  function MiddleNav() {
    (0, _classCallCheck3.default)(this, MiddleNav);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MiddleNav).call(this));

    _this.state = {
      isOpened: false
    };
    return _this;
  }

  (0, _createClass3.default)(MiddleNav, [{
    key: 'changeIsOpenedDiv',
    value: function changeIsOpenedDiv() {
      this.setState({
        isOpened: !this.state.isOpened
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./MiddleNav.scss');
      var images = this.props.images;

      var child = images.map(function (info, index) {
        var className = '';
        if (index === 0) {
          className = 'ml0';
        }
        return _react2.default.createElement(
          'li',
          { key: index, className: className, style: { marginTop: '16px' } },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/yyp/' + info.type },
            _react2.default.createElement('img', { src: info.img, alt: '' })
          )
        );
      });
      var others = [];
      if (images.length > 5) {
        child.splice(5, 0, _react2.default.createElement(
          'li',
          { key: 'additional', className: styles.additional, onClick: this.changeIsOpenedDiv.bind(this) },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/wbg/opbg.png', alt: '', className: styles.img1,
              style: { display: this.state.isOpened ? 'none' : 'block' } }),
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/wbg/opbg2.png', alt: '', className: styles.img1,
              style: { display: this.state.isOpened ? 'block' : 'none' } })
          )
        ));
        others = child.slice(6, child.length);
        child = child.slice(0, 6);
      }
      return _react2.default.createElement(
        'div',
        { style: { height: 'auto' } },
        _react2.default.createElement(
          'ul',
          { className: styles.op },
          child
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          _reactCollapse2.default,
          { isOpened: this.state.isOpened },
          _react2.default.createElement(
            'ul',
            { className: styles.op },
            others
          ),
          _react2.default.createElement('div', { className: 'clear' })
        )
      );
    }
  }]);
  return MiddleNav;
}(_react.Component), _class.propTypes = {
  images: _react.PropTypes.array.isRequired
}, _temp);
exports.default = MiddleNav;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MiddleNav/MiddleNav.js
 ** module id = 1373
 ** module chunks = 0
 **/